<template>
    <div>
        <div>
            Data
            <core-lever
                class="pl-2"
                :label="$t('services.info.navigation.schedule.separate-outward-return')"
                labelPosition="right"
                v-model="separateTransport"
            ></core-lever>
        </div>
        <template>
            <span class="d-flex table-title mt-4">{{ $t('services.info.navigation.schedule.dates-outbound') }}</span>
            <service-schedule-transport-time-period
                outbound
                :transportTimePeriods.sync="outboundPeriods"
                @select="outBoundPeriodSelected"
            ></service-schedule-transport-time-period>
        </template>
        <template v-if="separateTransport">
            <span class="d-flex table-title mt-4">{{ $t('services.info.navigation.schedule.dates-inbound') }}</span>
            <service-schedule-transport-time-period
                :transportTimePeriods.sync="returnPeriods"
                @select="returnPeriodSelected"
            ></service-schedule-transport-time-period>
        </template>
        <template>
            <span class="d-flex table-title mt-4">{{ $t('services.info.navigation.schedule.outbound-times') }}&nbsp;{{ outboundPeriodDate }}</span>
            <service-schedule-transport-time
                v-if="outboundPeriods.length"
                :key="outboundTimeCounter + 'outbound'"
                :transportTimes.sync="outboundPeriods[selectedOutboundIndex].transportTimes"
            ></service-schedule-transport-time>
        </template>
        <template v-if="separateTransport">
            <span class="d-flex table-title mt-4">{{ $t('services.info.navigation.schedule.inbound-times') }}&nbsp;{{ returnPeriodDate }}</span>
            <service-schedule-transport-time
                v-if="returnPeriods.length"
                :key="returnTimeCounter + 'return'"
                :transportTimes.sync="returnPeriods[selectedReturnIndex].transportTimes"
            ></service-schedule-transport-time>
        </template>
    </div>
</template>

<script>
export default {
  props: {
    service: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      outboundPeriods: [],
      returnPeriods: [],
      outboundTimes: [],
      returnTimes: [],
      separateTransport: false,
      outboundPeriod: {
        outbound: true,
        days: '0000000',
        transportTimes: []
      },
      returnPeriod: {
        outbound: false,
        days: '0000000',
        transportTimes: []
      },
      outboundTimeCounter: 0,
      returnTimeCounter: 0,
      selectedOutboundIndex: 0,
      selectedReturnIndex: 0
    }
  },
  computed: {
    outboundPeriodDate () {
      let dateFormat = ''
      if (this.outboundPeriods[this.selectedOutboundIndex]) {
        dateFormat = this.$moment(this.outboundPeriods[this.selectedOutboundIndex].dateFrom, 'YYYY-MM-DD').format('DD/MM/YY') +
          ' - ' +
          this.$moment(this.outboundPeriods[this.selectedOutboundIndex].dateUntil, 'YYYY-MM-DD').format('DD/MM/YY')
      }
      return dateFormat
    },
    returnPeriodDate () {
      let dateFormat = ''
      if (this.returnPeriods[this.selectedReturnIndex]) {
        dateFormat = this.$moment(this.returnPeriods[this.selectedReturnIndex].dateFrom, 'YYYY-MM-DD').format('DD/MM/YY') +
          ' - ' +
          this.$moment(this.returnPeriods[this.selectedReturnIndex].dateUntil, 'YYYY-MM-DD').format('DD/MM/YY')
      }
      return dateFormat
    }
  },
  async created () {
    if (this.service.hasOwnProperty('transportTimePeriods')) {
      this.service.transportTimePeriods.forEach((item) => {
        let isOutbound = !!+item.outbound
        if (isOutbound) {
          this.outboundPeriods.push(item)
        } else {
          this.returnPeriods.push(item)
        }
      })
    }
    if (!this.outboundPeriods.length && this.returnPeriods.length) {
      this.outboundPeriods.push(this.outboundPeriod)
    } else if (this.outboundPeriods.length && !this.returnPeriods.length) {
      this.returnPeriods.push(this.returnPeriod)
    }
    if (this.returnPeriods.length) {
      this.separateTransport = true
    }
  },
  methods: {
    refreshOutboundTime () {
      this.outboundTimeCounter += 1
    },
    refreshReturnTime () {
      this.returnTimeCounter += 1
    },
    outBoundPeriodSelected (index) {
      this.selectedOutboundIndex = index
      this.refreshOutboundTime()
    },
    returnPeriodSelected (index) {
      this.selectedReturnIndex = index
      this.refreshReturnTime()
    },
    addTimeToPeriods () {
      let items = []
      this.outboundPeriods.forEach((period) => {
        items.push(period)
      })
      this.returnPeriods.forEach((period) => {
        items.push(period)
      })
      this.service.transportTimePeriods = items
    }
  },
  watch: {
    outboundPeriods: {
      handler: 'addTimeToPeriods',
      deep: true
    },
    returnPeriods: {
      handler: 'addTimeToPeriods',
      deep: true
    },
    outboundPeriodTimes: {
      handler: 'addTimeToPeriods',
      deep: true
    },
    returnPeriodTimes: {
      handler: 'addTimeToPeriods',
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/service/schedule/Default.vue